// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';
import { StyleRoot } from 'radium';

import { MeetingroomOverview } from '../Components/index';
import { extractEventsFromViewer } from '../libs/Extract';
import { MEETINGROOMS_OVERVIEW_PAGE_SIZE } from '../../../config';

let meetingRoomsPageSize = MEETINGROOMS_OVERVIEW_PAGE_SIZE;
const fetchDelaySeconds = 3000;
const timeUpdateFrequency = 1000;
let nextDayCounter = 1;

const getStartDate : moment = () => moment().unix();
const getEndDate : moment = () => moment().endOf('day').unix();

class MeetingroomOverviewContainer extends Component {
  state: {
    hasMoreMeetingRooms: boolean,
    eventsFromNextDay: boolean,
  }

  state = {
    clock: moment(),
    hasMoreMeetingRooms: true,
    eventsFromNextDay: false,
  }

  componentDidMount() {
    this._meetingRoomsPoller = setInterval(this._loadMore, fetchDelaySeconds);
    this._timePoller = setInterval(this._updateTime, timeUpdateFrequency);
    this.update();
  }

  componentWillReceiveProps() {
    if (!this.state.hasMoreMeetingRooms) {
      clearInterval(this._meetingRoomsPoller);
    }
  }

  componentWillUnmount() {
    clearInterval(this._meetingRoomsPoller);
    clearInterval(this._timePoller);
  }
  _meetingRoomsPoller: number;
  _timePoller: number;
  props: {
    languagedata: Object,
    viewer: Object,
    relay: Object,
    location: Object,
  }

  _updateTime = () => {
    this.setState({
      clock: moment(),
    });
  }

  update = () => {
    // Refresh the events
    setInterval(() => {
      this.props.relay.forceFetch({
        startDate: getStartDate(),
        endDate: getEndDate(),
      });
    }, 300000);
  }

  _loadMore = () => {
    const meetingroomsHasNextPage = this.props.viewer.meetingRooms.pageInfo.hasNextPage;
    meetingRoomsPageSize += MEETINGROOMS_OVERVIEW_PAGE_SIZE;
    this.props.relay.setVariables({
      meetingRoomsPageSize,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({
          hasMoreMeetingRooms: meetingroomsHasNextPage,
        });
      } else if (readyState.error) {
        this.setState({
          hasMoreMeetingRooms: false,
        });
      }
    });
  }

  _onToggle = (theme) => {
    this.props.location.query.theme = theme;
    this.forceUpdate();
  }

  _fetchNextDayEvents = () => {
    const startDate = moment.unix(getStartDate());
    const endDate = moment.unix(getEndDate());
    // clone startDate/endDate since moment object a mutable
    let startDateClone = startDate.clone();
    let endDateClone = endDate.clone();
    // add one day and convert to unix
    startDateClone = startDateClone.add(1, 'day').unix();
    endDateClone = endDateClone.add(1, 'day').unix();
    if (nextDayCounter === 1) {
      this.props.relay.forceFetch({
        startDate: startDateClone,
        endDate: endDateClone,
      }, () => {
        nextDayCounter++;
        this.setState({
          eventsFromNextDay: true,
        });
      });
    }
  }

  render() {
    const theme = this.props.location.query.theme === 'light' ? 'light' : 'dark';
    const events = extractEventsFromViewer(this.props.viewer);
    // if no events today fetch the next day events.
    if (events.length === 0) {
      this._fetchNextDayEvents();
    }
    return (
      <StyleRoot>
        <MeetingroomOverview
          languagedata={this.props.languagedata}
          events={events}
          clock={this.state.clock}
          theme={theme}
          onToggle={this._onToggle}
          eventsFromNextDay={this.state.eventsFromNextDay}
        />
      </StyleRoot>
    );
  }

}

export default Relay.createContainer(MeetingroomOverviewContainer, {
  initialVariables: {
    meetingRoomsPageSize,
    startDate: getStartDate(),
    endDate: getEndDate(),
    locationFilter: null,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        meetingRooms(first: $meetingRoomsPageSize, location: $locationFilter) {
          edges {
            node {
              id
              displayName
              events (first: 10000, startDate: $startDate, endDate: $endDate, organizerView: true) {
                edges {
                  node {
                    subject
                    startDate
                    endDate
                    location {
                      displayName
                    }
                    organizer {
                      displayName
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Containers/MeetingroomOverviewContainer.js